export default "__VITE_ASSET__BST8qurE__"